<template>
  <div>
    <h2>Đăng nhập để thi thử</h2>

    <p class="text-justify">Kho bài thi đánh giá năng lực tiếng Trung chất lượng hàng đầu cho tất cả các trình độ HSK 1, HSK 2, HSK 3, HSK 4, HSK 5, HSK 6. Tất cả các câu hỏi trong đề thi đều được biên soạn bởi các giáo viên có nhiều năm kinh nghiệm, đề thi được xây dựng dựa trên ma trận đề thi thật.</p>

    <b-alert show="10" v-model="showErrors" variant="danger" dismissible>
      Vui lòng kiểm tra lại tên đăng nhập / mật khẩu!
    </b-alert>

    <b-form @submit="onSubmit" @reset="onReset" v-if="show" class="auth__form">
      <b-input-group
        id="input-email"
        label="Email address:"
        label-for="email"
      >
        <b-input-group-append class="auth__form__icon">
          <fa-icon icon="envelope" />
        </b-input-group-append>
        <b-form-input
          id="email"
          v-model="form.email"
          type="email"
          required
          placeholder="Email của bạn"
          class="auth__form__input"
        ></b-form-input>
      </b-input-group>

      <b-input-group
        id="input-password"
        label="Mật khẩu:"
        label-for="password"
      >
        <b-input-group-append class="auth__form__icon">
          <fa-icon icon="lock" />
        </b-input-group-append>
        <b-form-input
          id="password"
          v-model="form.password"
          :type="isHiddenPassword ? 'password' : 'text'"
          required
          placeholder="Mật khẩu của bạn"
          class="auth__form__input"
        ></b-form-input>
        <b-input-group-append 
          class="auth__form__icon"
          @click="isHiddenPassword = !isHiddenPassword">
          <fa-icon :icon="isHiddenPassword ? 'eye' : 'eye-slash' " />
        </b-input-group-append>
      </b-input-group>

      <div class="lst-action-form">
        <b-button type="submit" class="auth__form__btn">Đăng nhập</b-button>
        <span>Hoặc</span>
        <router-link :to="{ name: 'auth-mobiedu', query: nextUrl ? { nextUrl } : {} }" class="btn auth__more__btn text-white">Đăng nhập bằng tài khoản MobiEdu</router-link>
      </div>

      <p>Bạn chưa có tài khoản? Hãy <router-link :to="{ name: 'auth-register', query: nextUrl ? { nextUrl } : {} }">Đăng ký</router-link></p>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      nextUrl: '',
      show: true,
      isHiddenPassword: true,
      showErrors: false
    }
  },
  computed: {
    ...mapState('auth', ['isLoggedIn', 'error'])
  },
  watch: {
    error(value) {
      if(value != null) {
        this.showErrors = true;
      }
    }
  },
  created() {
    this.nextUrl = this.$route.query.nextUrl || this.$route.query.redirect || '';
  },
  methods: {
    ...mapActions(`auth`, ['authLogin', 'clearData']),
    onSubmit(evt) {
      evt.preventDefault()
      this.authLogin({... this.form, nextUrl: this.nextUrl})
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.email = ''
      this.form.password = ''
      // Trick to reset/clear native browser form validation state
      this.show = false
    }
  },
  beforeDestroy() {
    this.clearData()
  }
}
</script>

<style scoped>
.lst-action-form {
  display: flex;
  align-items: center;
  gap: 20px;

  span {
    margin-bottom: 1.5rem;
  }
}

.auth__more__btn {
  margin-bottom: 1.5rem;
  background: #0061b0;
  border-radius: 0;
}
</style>